import { Skeleton } from '../skeleton'

const DataCardSkeleton = () => {
  return Array.from({ length: 4 }).map((_, index) => (
    <Skeleton key={index} className="h-16 w-full bg-white" />
  ))
}
DataCardSkeleton.displayName = 'DataCardSkeleton'

export { DataCardSkeleton }
